import cx from 'classnames';
import { Button } from 'react-bootstrap';
import { PlusLg } from 'react-bootstrap-icons';
import { Link } from 'react-router-dom';

// Normal buttons

export function PrimaryButton({ children, ...props }) {
    return (
        <GenericButton variant="primary" {...props}>
            {children}
        </GenericButton>
    );
}

export function SecondaryButton({ children, ...props }) {
    return (
        <GenericButton variant="secondary" {...props}>
            {children}
        </GenericButton>
    );
}

export function SuccessButton({ children, ...props }) {
    return (
        <GenericButton variant="success" {...props}>
            {children}
        </GenericButton>
    );
}

export function InfoButton({ children, ...props }) {
    return (
        <GenericButton variant="info" {...props}>
            {children}
        </GenericButton>
    );
}

export function WarningButton({ children, ...props }) {
    return (
        <GenericButton variant="warning" {...props}>
            {children}
        </GenericButton>
    );
}

export function DangerButton({ children, ...props }) {
    return (
        <GenericButton variant="danger" {...props}>
            {children}
        </GenericButton>
    );
}

export function LinkButton({ children, ...props }) {
    return (
        <GenericButton variant="link" {...props}>
            {children}
        </GenericButton>
    );
}

export function GenericButton({ children, tooltip, ...props }) {
    return (
        <Button {...props} data-uk-tooltip={tooltip}>
            {children}
        </Button>
    );
}

export function NewItemButton({ icon = <PlusLg />, label, ...props }) {
    return (
        <InfoButton className="d-flex align-items-center" {...props}>
            {icon}
            <div>{label}</div>
        </InfoButton>
    );
}

// Button as Link

export function PrimaryLinkButton({ to = '', children, ...props }) {
    return (
        <PrimaryButton as={Link} to={to} {...props}>
            {children}
        </PrimaryButton>
    );
}

export function LightOutlineLinkButton({ to = '', children, ...props }) {
    return (
        <PrimaryButton as={Link} to={to} variant="outline-light" {...props}>
            {children}
        </PrimaryButton>
    );
}

export function ActionLinkButton({ children, ...props }) {
    return (
        <GenericButton variant="action" {...props}>
            {children}
        </GenericButton>
    );
}

export function ActionLink({ to, tooltip = undefined, children, ...props }) {
    return (
        <Link to={to} className="btn-action-link" data-uk-tooltip={tooltip} {...props}>
            {children}
        </Link>
    );
}

// Icon buttons

export function IconButton({ icon, className = undefined, size = undefined, title, ...props }) {
    return (
        <GenericButton
            className={cx('btn-icon flex-shrink-0 text-body', className, {
                'btn-lg': size === 'lg',
                'btn-sm': size === 'sm',
            })}
            variant="link"
            title={title}
            {...props}
        >
            {icon}
        </GenericButton>
    );
}

export function IconOutlineButton({ icon, className, tooltip, disabled = false, onClick }) {
    return (
        <button
            className={cx('btn-icon-outline', className)}
            data-uk-tooltip={tooltip}
            disabled={disabled}
            onClick={onClick}
        >
            {icon}
        </button>
    );
}

// Outline button

export function LightOutlineButton({ className, children, ...props }) {
    return (
        <GenericButton className={cx('flex-center', className)} variant="outline-light" {...props}>
            {children}
        </GenericButton>
    );
}
